import { PropsWithChildren, ReactElement } from 'react';
import { MatchProvider, wagmiConfig } from '@matchain/matchid-sdk-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { WagmiProvider } from 'wagmi';

import { useWatchMatchId } from 'modules/auth/hooks/useWatchMatchId';

const queryClient = new QueryClient();

export function MatchIdConnectionProvider({
  children,
}: PropsWithChildren): ReactElement {
  return (
    <WagmiProvider config={wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <MatchProvider
          appid={import.meta.env.VITE_MATCH_APP_ID}
          wallet={{ type: 'UserPasscode' }}
        >
          <MatchIdWatcher />

          {children}
        </MatchProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}

function MatchIdWatcher(): null {
  useWatchMatchId();

  return null;
}
